<div class="footer-inner">
  @if (footerService.showMediaButtons()) {
    <div class="media-buttons">
      <qai-call-button
        [label]="'call.CAPTIONS_LABEL' | transloco"
        [kind]="footerService.captionsOn() ? 'tertiary' : 'destructive'"
        [icon]="footerService.captionsOn() ? 'captions' : 'captions-off'"
        (clicked)="onCaptionsClick()"
      />
      <qai-call-button
        [label]="'call.AUDIO' | transloco"
        [kind]="footerService.isMicOn() ? 'tertiary' : 'destructive'"
        [icon]="footerService.isMicOn() ? 'microphone' : 'microphone-off'"
        (clicked)="onMicrophoneClick()"
      />
      @if (footerService.shouldShowVideoButton()) {
        <qai-call-button
          [label]="'call.VIDEO_LABEL' | transloco"
          [kind]="footerService.isVideoOn() && footerService.isCameraAvailable ? 'tertiary' : 'destructive'"
          [icon]="footerService.isVideoOn() && footerService.isCameraAvailable ? 'video-recorder' : 'video-recorder-off'"
          [errorBadge]="!footerService.isCameraAvailable"
          [matTooltipDisabled]="footerService.isCameraAvailable"
          matTooltipClass="cameraUnavailable"
          [matTooltip]="'call.BROWSER_ACCESS_DENIED' | transloco"
          (clicked)="onVideoClick()"
        />
      }
    </div>
  }

  <button
    qai-button
    [kind]="footerService.actionKind()"
    size="large"
    [disabled]="footerService.isActionDisabled()"
    (click)="onActionClick()"
  >
    @if (footerService.isActive()) {
      <qai-icon kind="phone-call" positionStart />
    }
    {{ footerService.actionLabel() | transloco }}
  </button>
</div>
